<template>
  <div class="follow-list">
    <scroll-comp ref="scrollComp" :page-load="getList">
      <div :class="[classBase + 'list']" class="list-group">
        <template>
          <div v-for="item in list" :key="item.id" class="item">
            <a>
              <img :src="handleImgSize(handleUser(item).avatar, 'list')" alt="" />
              <div>
                <p class="username">{{ handleUser(item).username }}</p>
                <p class="sign">{{ handleUser(item).sign }}&nbsp;</p>
              </div>
            </a>
            <el-button
              v-if="$route.params.type == 1"
              :size="device.desktop ? '' : 'mini'"
              plain
              type="danger"
              @click="onFollow(item)"
              >取消关注
            </el-button>
            <el-button
              v-if="$route.params.type == 2"
              :plain="handleUser(item).mutual_followed == 1 ? true : false"
              :size="device.desktop ? '' : 'mini'"
              :type="handleUser(item).mutual_followed == 1 ? 'danger' : 'primary'"
              @click="onFollow(item)"
            >
              {{ handleUser(item).mutual_followed == 1 ? "取消关注" : "关注" }}
            </el-button>
          </div>
        </template>
      </div>
    </scroll-comp>
  </div>
</template>

<script>
import { apiUserFollowList, apiUserAddFollow } from "@/api/userApi";
import ScrollComp from "@/components/Scroll";

export default {
  name: "myFollow",
  mixins: [],
  props: {},
  model: {},
  components: { ScrollComp },
  data() {
    return {
      pagination: {
        limit: 20,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      list: []
    };
  },
  computed: {},
  methods: {
    handleUser(item) {
      return this.$route.params.type == 1 ? item.user_info : item.follow_user_info;
    },
    onFollow(item) {
      let { type } = this.$route.params;
      let uid = item.user_info.uid;
      // 我的粉丝
      if (type == 2) {
        uid = item.follow_user_info.uid;
      }
      apiUserAddFollow({
        follow_uid: uid
      }).then(res => {
        if (type == 1) {
          this.list.splice(this.list.indexOf(item), 1);
        } else if (type == 2) {
          item.follow_user_info.mutual_followed = item.follow_user_info.mutual_followed == 1 ? 0 : 1;
        }
      });
    },
    getList() {
      let { pagination, $refs, $route } = this;
      if ($refs.scrollComp.loadStatus == "end") {
        return;
      }
      ++pagination.page_no;
      let params = {
        ...pagination,
        uid: $route.params.id,
        type: this.$route.params.type
      };
      $refs.scrollComp.loadStatus = "loading";
      apiUserFollowList(params)
        .then(res => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data);
            this.pagination = res.meta.pagination;
          }
        })
        .finally(_ => {
          $refs.scrollComp.loadStatus = "";
          console.log(this.pagination);
          // 达到最大页数后，不触发翻页方法；
          if (this.pagination.page_no >= this.pagination.page_total) {
            $refs.scrollComp.loadStatus = "end";
          }
        });
    }
  },
  watch: {
    $route: function(val, oldVal) {
      this.pagination = {
        limit: 20,
        page_no: 0,
        page_tatal: 1,
        total: 0
      };
      this.list = [];
      this.$refs.scrollComp.loadStatus = "";
      this.getList();
    }
  },
  created() {},
  mounted() {
    this.getList();
  },
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.follow-list {
  padding: 16px 28px;
}
.list-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .item {
    width: 49%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f7f7f7;
    border-radius: 4px;
    height: 84px;
    padding: 0 20px;
    margin-bottom: 20px;

    a {
      display: flex;
      align-items: stretch;

      img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        object-fit: cover;
      }

      > div {
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        flex: 1;

        .username {
          color: #333;
          max-width: 120px;
        }

        .sign {
          .ellipsis;
          color: #9e9e9e;
          font-size: 12px;
          max-width: 150px;
        }
      }
    }
  }
}

.wap-list {
  .item {
    width: 100%;
    margin-bottom: 12px;
    padding: 12px;
    height: 56px;

    a {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }
}
</style>
